import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=5e049ed3&"
import script from "./ProductsView.vue?vue&type=script&lang=js&"
export * from "./ProductsView.vue?vue&type=script&lang=js&"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=5e049ed3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports